(function ($) {
    "use strict";

    $.checkHash = function checkHash() {
        var hash = window.location.hash;
        var $initial__tab = 0;

        if (hash.length > 0) {
            if ($(hash).length && !$(hash).hasClass("iziModal")) {
                $("html, body").animate(
                    {
                        scrollTop: $(hash).offset().top - $("header").height(),
                    },
                    1000
                );
            } else {
                $(hash + ".js-open-w-hash").iziModal("open", {
                    transitionIn: "fadeInRight",
                    transitionOut: "fadeOutRight",
                });
            }
        }
    };


})(jQuery);
